"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var GenericInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onChange = function onChange(event) {
    event.preventDefault();
    var target = event.target;
    var update = {
      name: props.name,
      value: target.value
    };
    props.onChange(update);
  };

  var name = props.name,
      value = props.value,
      type = props.type,
      id = props.id,
      attr = props.attr,
      className = props.className,
      placeholder = props.placeholder,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onKeyDown = props.onKeyDown;
  return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    ref: ref,
    className: className,
    id: id,
    type: type,
    name: name,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown
  }, attr));
});

GenericInput.propTypes = {
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  type: _propTypes["default"].string,
  attr: _propTypes["default"].shape(),
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func
};
GenericInput.defaultProps = {
  type: 'text',
  attr: {},
  placeholder: '',
  className: '',
  onClick: function onClick() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  value: ''
};
GenericInput.displayName = 'GenericInput';
var _default = GenericInput;
exports["default"] = _default;